<div class="header-actions">
  <button
    [disabled]="buttonsDisabled"
    mat-stroked-button
    class="save-button"
    id="SaveTranslation"
    (click)="translationApproved.emit(false)"
  >
    <mat-icon svgIcon="ic_save">save</mat-icon>
  </button>

  <button [disabled]="buttonsDisabled" mat-button class="btn btn-primary" id="ApproveTranslation" (click)="translationApproved.emit(true)">
    {{ 'RECIPE_TRANSLATION.BUTTON.APPROVE' | translate }}
  </button>
</div>
